import {Typography} from "@mui/material";
import moment from "moment";
import React from "react";
import { StepperChildrenProps } from ".";

export default function LabelSubtitle({
    tarefa,
    existeErro,
    estaCancelada
}: LabelSubtitleProps) {


    if (!tarefa.resolvida_em) return (
        <>
            <Typography component="div" variant="caption" sx={{color: estaCancelada ? 'error.main' : 'text.secondary'}}>
                    {estaCancelada ? 'Cancelada' : 'Em andamento'}
            </Typography>
            {
                (tarefa.perfil || tarefa.usuario) &&
                <Typography component="div" variant="caption" sx={{color: estaCancelada ? 'error.main' : 'text.secondary'}}>Responsável: {tarefa.perfil?.nome} {tarefa.usuario && ` / ` + tarefa.usuario.nome}</Typography>
            }
        </>
    )

    return (
        <>
            <Typography component="div" variant="caption">
                Resolvida {tarefa.resolvida_por ? `por ${tarefa.resolvida_por}` : ''} em {moment(tarefa.resolvida_em).format('DD/MM/YYYY HH:mm')}
            </Typography>
        </>
    )


    return (<React.Fragment />)
}

interface LabelSubtitleProps extends StepperChildrenProps {
    existeErro: boolean
    estaCancelada: boolean
}